import { useEffect, useState } from "react";

import {
  applyFitTextToControl,
  isFitTextEnabled,
  setFitTextEnabled
} from "@/helpers/editor/command-style";

import { ContextMenuItem } from "@/components/ui/context-menu";
import Modal from "@/components/ui/modal";
import { Switch } from "@/components/ui/switch";

import TextStyleControls from "../../toolbar-buttons/text-style-controls";

type Props = {
  editorRef: React.RefObject<HTMLDivElement>;
  rightClickedElement: HTMLElement;
  title: string;
  description: string;
};

const AppearanceModal: React.FC<Props> = ({
  editorRef,
  rightClickedElement,
  title,
  description
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isFitText, setIsFitText] = useState(false);

  useEffect(() => {
    setIsFitText(isFitTextEnabled(rightClickedElement));
  }, [rightClickedElement]);

  const openModal = () => {
    if (editorRef.current) {
      rightClickedElement.focus?.();
    }

    setIsFitText(isFitTextEnabled(rightClickedElement));
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const toggleFitText = (enabled: boolean) => {
    setIsFitText(enabled);
    setFitTextEnabled(rightClickedElement, enabled);

    if (enabled) {
      applyFitTextToControl(rightClickedElement);
    }

    editorRef.current?.focus();
  };

  return (
    <>
      <ContextMenuItem onSelect={openModal}>{title}</ContextMenuItem>

      <Modal
        title={title}
        description={description}
        isOpen={isOpen}
        onClose={closeModal}
      >
        <div className="space-y-4 pt-2">
          <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
            <TextStyleControls editorRef={editorRef} />
          </div>

          <label className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm">
            <span className="font-medium text-slate-700">فیت با متن</span>
            <Switch checked={isFitText} onCheckedChange={toggleFitText} />
          </label>
        </div>
      </Modal>
    </>
  );
};

export default AppearanceModal;
